export const DEFAULT_LANGUAGE_CONFIG_OBJ_KEY = 'emisoft-internalization';
export const LOCALES = {
  ENGLISH: 'en',
  VIETNAMESE: 'vi',
};
